<template>
    <div class="modal-dialog" role="dialog" tabindex="0" @click.stop>
      <div class="modal-content">
        <header id="modalTitle" class="modal-header">
          <slot name="header">
            <h3>{{ title || 'Default title' }}</h3>
          </slot>
        </header>

        <section id="modalDescription" class="modal-body">
          <slot name="body"> Default body </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            <SpButton
              v-if="submitButton"
              aria-label="Submit"
              type="primary"
              @click="$emit('submit')"
            >
              Save changes
            </SpButton>
            <SpButton
              v-if="cancelButton"
              aria-label="Close modal"
              type="secondary"
              @click="$emit('close')"
            >
              Cancel
            </SpButton>
          </slot>
        </footer>

        <SpTimesIcon
          v-if="closeIcon"
          class="modal__close-icon"
          style="position: absolute; top: 26px; right: 20px; cursor: pointer"
          @click="$emit('close')"
        >
          Close
        </SpTimesIcon>
      </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

import SpButton from '../SpButton'
import SpTimesIcon from '../SpTimesIcon'

export default defineComponent({
  name: 'DysModal',

  components: { SpButton, SpTimesIcon },

  props: {
    visible: {
      type: Boolean,
      defaultsTo: false
    },
    title: {
      type: String,
      defaultsTo: null
    },
    submitButton: {
      type: Boolean,
      defaultsTo: true
    },
    closeIcon: {
      type: Boolean,
      defaultsTo: true
    },
    cancelButton: {
      type: Boolean,
      defaultsTo: true
    }
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        document.addEventListener('keyup', this.escapeHandler)
      } else {
        document.removeEventListener('keyup', this.escapeHandler)
      }
    }
  },
  methods: {
    escapeHandler(evt) {
      if (evt.key === 'Escape') this.$emit('close')
    }
  }
})
</script>

<style lang="scss" scoped></style>
